import { render, staticRenderFns } from "./StarSubMenu.vue?vue&type=template&id=b8902ea8&scoped=true"
import script from "./StarSubMenu.vue?vue&type=script&lang=js"
export * from "./StarSubMenu.vue?vue&type=script&lang=js"
import style0 from "./StarSubMenu.vue?vue&type=style&index=0&id=b8902ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8902ea8",
  null
  
)

export default component.exports